import React from 'react';
import Footer from '../Pages/Footer';
import Navbar from '../Navbar';
import SEO from '../components/SEO';
import { useSiteConfig } from '../contexts/SiteConfigContext';

export default function Services() {
  const { config } = useSiteConfig();
  const services = config.services?.list || [];

  return (
    <div>
      <SEO
        title="Nos Services — Gestion, Vente & Conciergerie"
        description="SCI MAYEDO vous propose des services immobiliers complets : gestion locative, vente de biens, conciergerie, accompagnement juridique et administratif en Côte d'Ivoire."
        canonical="/services"
      />
      <Navbar />

      <div className='container' style={{ padding: "3rem 1.5rem" }}>
        <h2 style={{ textAlign: "center", color: "#1B4F9E", marginBottom: "0.5rem" }}>Nos Services</h2>
        <p style={{ textAlign: "center", color: "#5a6e8c", marginBottom: "2.5rem" }}>
          Découvrez l'ensemble des services proposés par SCI MAYEDO
        </p>

        {services.length === 0 ? (
          <p style={{ textAlign: "center", color: "#9ca3af" }}>Aucun service configuré pour le moment.</p>
        ) : (
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: "1.5rem",
          }}>
            {services.map((svc, i) => (
              <div key={i} style={{
                background: "#fff",
                borderRadius: 14,
                padding: "1.8rem",
                boxShadow: "0 4px 18px rgba(27,79,158,0.1)",
                borderTop: "4px solid #1B4F9E",
                display: "flex",
                flexDirection: "column",
                gap: "0.8rem",
              }}>
                <div style={{
                  width: 52, height: 52, borderRadius: 12,
                  background: "#E6EEF9", display: "flex",
                  alignItems: "center", justifyContent: "center",
                }}>
                  <i className={`fa-solid ${svc.icon || "fa-star"}`}
                    style={{ fontSize: "1.4rem", color: "#1B4F9E" }}></i>
                </div>
                <h3 style={{ margin: 0, fontSize: "1.05rem", color: "#0f1f3d" }}>{svc.title}</h3>
                <p style={{ margin: 0, color: "#5a6e8c", fontSize: "0.9rem", lineHeight: 1.6 }}>
                  {svc.description}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}
